import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('announcement/list', { params });
  },
  async add(params: any) {
    return axios.post('announcement/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('announcement/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('announcement/detail', { params });
  },
  async delete(params: any) {
    return axios.post('announcement/delete', qs.stringify(params));
  }
};
